export default "__VITE_ASSET__om1qCk7S__"